// Notion Create Repair (2026-10) — stored/returned Notion errors (dal.py, deliverable_sync.py)
// are raw diagnostic strings like:
//   RuntimeError: knowledge_store_error create_failed status=400 body={"object":"error",
//   "code":"validation_error","message":"body.properties.Shoot Dates.date.start should be
//   a valid ISO 8601 date string"}
// This pulls out the property name + Notion's own message for a clean, user-facing
// "Notion rejected: <property>: <message>" — used by both the banner and the retry toast so
// the formatting only lives in one place. Returns null for non-Notion errors (no_remote_id,
// record_not_found, retry_in_progress, etc.) so callers keep their own fallback wording.
export function formatNotionError(raw) {
  if (!raw || typeof raw !== "string") return null;
  const messageMatch = raw.match(/"message":"((?:[^"\\]|\\.)*)"/);
  if (!messageMatch) return null;
  const message = messageMatch[1].replace(/\\"/g, '"');
  const propertyMatch = message.match(/properties\.([^."]+)/);
  return propertyMatch ? `Notion rejected: ${propertyMatch[1]}: ${message}` : `Notion rejected: ${message}`;
}
